import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Pagination as BsPaginator } from 'react-bootstrap'

export const Pagination = props => {
  let buttons = []
  let totalPages = Math.ceil(props.total / props.rate)

  for (let i = 1; i <= totalPages; i++) {
    buttons.push(
      <li
        key={i}
        className={i === props.currentPage ? 'active' : null}
        onClick={() => props.setCurrentPage(i)}
      >
        <a>{i}</a>
      </li>
    )
  }

  let prevBtn =
    props.currentPage === 1 ? null : (
      <li onClick={() => props.setCurrentPage(props.currentPage - 1)}>
        <a aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
    )

  let nextBtn =
    props.currentPage === totalPages ? null : (
      <li onClick={() => props.setCurrentPage(props.currentPage + 1)}>
        <a aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    )

  return (
    <Fragment>
      <ul className="pagination">
        {prevBtn}
        {buttons}
        {nextBtn}
      </ul>
    </Fragment>
  )
}

Pagination.propTypes = {
  currentPage: PropTypes.number,
  rate: PropTypes.number,
  total: PropTypes.number,
  setCurrentPage: PropTypes.func,
}

export const BootstrapPaginator = ({
  itemCount, // how many items in total across all pages
  pageItemLimit, // number of items on the page; must match server-side paginator value
  currentPageNum, // active page index
  updatePageFunc, // function you use to change the page num; use hooks to update data
  updateFuncArgs,
  maxButtons = 5, // number of numbered page buttons between arrow buttons
}) => {
  return (
    <BsPaginator
      prev={<span className="text-dark">{'<'}</span>}
      next={<span className="text-dark">{'>'}</span>}
      first={<span className="text-dark">{'<<'}</span>}
      last={<span className="text-dark">{'>>'}</span>}
      maxButtons={maxButtons}
      items={Math.ceil(itemCount / pageItemLimit)}
      activePage={Number(currentPageNum)}
      onSelect={page => {
        updatePageFunc({ pageNum: page, ...updateFuncArgs })
      }}
    />
  )
}

export const itemIdxDisplayer = (
  perPage,
  pageNum,
  pageItemCount,
  totalItemCount
) => {
  let baseIdx = perPage * (pageNum - 1)
  let startIdx = totalItemCount > 0 ? baseIdx + 1 : baseIdx
  return ` ${startIdx} - ${baseIdx + pageItemCount} of ${totalItemCount} `
}
